export const colors = {
    primaryColor: '#28BEBE',
    secondaryColor: '#F5F5B9',
    darkGrey: '#464646',
    lightGrey: '#1E1E1E',
};